// i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import en from "./en.json";
import ar from './ar.json'
import "moment/locale/de";

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ar: {
        translation: ar,
    },
  },
  lng: "en", // Set the default language
  fallbackLng: "ar", // Fallback language
  interpolation: {
    escapeValue: false, // React already escapes values by default
  },
});

i18n.on("languageChanged", (lng) => {
  moment.locale(lng);
});

export default i18n;
